module.exports = __webpack_public_path__ + "media/images/athletes/1346-bf88693353cd27b01aefb8f31274283a.png";